import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_disposal,
    getReportLabel: () => t`Disposal Schedule`,
    getColumns: () => [],
};
